var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeorgia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M13.5-.003h-3V6.5H0v3h10.5v6.502h3V9.5H24v-3H13.5V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M5.775 2.727V1.685h-1.05v1.042H3.682V3.77h1.043v1.042h1.05V3.77h1.042V2.727H5.775zm13.5 0V1.685h-1.05v1.042h-1.043V3.77h1.043v1.042h1.05V3.77h1.042V2.727h-1.042zm-13.5 9.503v-1.043h-1.05v1.043H3.682v1.042h1.043v1.043h1.05v-1.043h1.042V12.23H5.775zm13.5 0v-1.043h-1.05v1.043h-1.043v1.042h1.043v1.043h1.05v-1.043h1.042V12.23h-1.042z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgia);
export default __webpack_public_path__ + "static/media/Georgia.ef1df38467376c4dab6758eb8fecfb83.svg";
export { ForwardRef as ReactComponent };